import React from 'react';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import * as styles from './DraftPostItem.scss';

function DraftPostTopBar(props) {
  var approveDraftPost = props.approveDraftPost,
      handleEdit = props.handleEdit,
      organization = props.organization,
      post = props.post,
      setSnackbarMessage = props.setSnackbarMessage;
  return /*#__PURE__*/React.createElement("div", null, post.DraftPost.approvedAt ? /*#__PURE__*/React.createElement("div", {
    className: styles.topBar
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#616161',
      flex: '1 1 100%',
      paddingRight: 12
    }
  }, "Approved by ", post.DraftPost.approvedByUserEmail, " on", ' ', moment(post.DraftPost.approvedAt).format('MM/DD/YYYY [at] h:mm a')), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 320
    }
  }, /*#__PURE__*/React.createElement(RaisedButton, {
    onClick: function onClick() {
      return handleEdit(post, true);
    },
    label: "Schedule Post",
    secondary: true,
    style: {
      marginRight: 24
    }
  }), /*#__PURE__*/React.createElement(RaisedButton, {
    onClick: function onClick() {
      if (window.confirm('This post has already been approved. Are you sure you want to mark it unapproved?')) {
        approveDraftPost(organization.id, post.id, false);
        setSnackbarMessage('Post marked unapproved.');
      }
    },
    label: "Mark Unapproved"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: styles.topBar
  }, post.DraftPost.requestedApprovalAt ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#616161'
    }
  }, "Sent for approval on ", moment(post.DraftPost.requestedApprovalAt).format('MM/DD/YYYY [at] h:mm a')) : /*#__PURE__*/React.createElement("span", null, " "), /*#__PURE__*/React.createElement(RaisedButton, {
    onClick: function onClick() {
      approveDraftPost(organization.id, post.id);
      setSnackbarMessage('Post marked approved.');
    },
    label: "Mark Approved"
  })));
}

export default DraftPostTopBar;